export default __webpack_public_path__ + "static/media/big-dog-solar-bg.97e31ec6.jpeg";